class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.header = document.querySelector('.header__logo-wrapperSmall');
    this.closeBtn  = this.querySelector('.search-modal__close-button');
    this.overlayClose = this.querySelector('.modal-overlay');

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));

    // Close only on a pointerdown OUTSIDE the modal, checked synchronously at
    // the moment of interaction (covers mouse, touch, and pen alike) - this
    // is what actually decides closing now; see onFocusOut for why blur
    // timing alone can't be trusted here. Capture phase so a descendant
    // (e.g. the results' product-grid swiper, which stopPropagation()s its
    // own drag events) can't hide the interaction from this listener.
    document.addEventListener('pointerdown', (e) => {
      if (!this.isOpen() || this.contains(e.target)) return;
      this.close();
    }, { capture: true });

    this.summaryToggle.setAttribute('role', 'button');
    this.attechEventListner();
  }

  attechEventListner(){
    this.closeBtn.addEventListener('click', function(){
      this.close();
      console.log("lalalal");
    }.bind(this));

    this.overlayClose.addEventListener('click', function(){
      this.close();
    }.bind(this));
  }


  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  getResultsMaxHeight() {
    const headerBottom = document.querySelector('.section-header')?.getBoundingClientRect().bottom || 0;
    return window.innerHeight - headerBottom;
  }

  onSummaryClick(event) {
    event.preventDefault();
    const isOpen = event.target.closest('details').hasAttribute('open');
    isOpen ? this.close() : this.open(event);
  }

  onFocusOut(event) {
    if (!this.isOpen()) return;

    // Closing on pointer interaction (mouse drag, touch, tap) is handled
    // entirely by the pointerdown-outside listener in the constructor -
    // synchronous containment check, no timing race with blur/focusout (the
    // old `_swiperDragging` + setTimeout approach here reset its guard only
    // 100ms after the product-grid swiper's own touchEnd callback, which
    // routinely elapsed before the resulting blur actually landed, closing
    // the search mid-drag). This only needs to catch keyboard-driven focus
    // loss (Tab-ing past the last focusable element) - relatedTarget
    // reliably tells us where focus landed for that case, synchronously.
    if (this._keyboardDismissed) return;
    if (document.querySelector('.mobile-size__selector.is-open, .mobile-size__selector.is-closing')) return;

    const nextFocus = event.relatedTarget;
    if (!nextFocus || this.contains(nextFocus)) return;
    this.close(false);
  }

  open(event) {
    const detailsElement =
    (event?.target && event.target.closest('details')) ||
    (event?.closest && event.closest('details')) ||
    this.detailsContainer; 
    const headerSearch = detailsElement.closest('.header__search-wrapper');
    if (headerSearch) {
      headerSearch.style.setProperty('display', 'flex', 'important');
    }
    const headerHeight = this.header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    
    detailsElement.setAttribute('open', "");
    detailsElement.setAttribute('aria-expanded', "true");

    // `overflow: hidden` on body alone doesn't stop touch scrolling on iOS
    // Safari - once a drag inside the results list reaches the top/bottom of
    // its own scroll range, the page behind the modal starts scrolling too.
    // Locking body with position: fixed (restoring the exact scroll offset on
    // close) is what actually prevents that on real iOS devices.
    this.scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    document.body.classList.add('overflow-hidden');
    document.body.classList.remove('overflow-hidden-tablet');

    if (this.querySelector('.search-modal__content')) {
      document.body.classList.add('search-modal-open');
    }

    // Trap focus inside modal
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    // Calculate and apply max-height
    const maxHeightValue = `${this.getResultsMaxHeight()}px`;
    this.resultsMaxHeight = maxHeightValue;

    // Ensure we're selecting the predictive search within the modal
    this.predictiveSearchResults = this.detailsContainer.querySelector('.predictive-search--wrapper');

    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.style.setProperty('max-height', maxHeightValue);
    } else {
      console.warn('Predictive search wrapper not found.');
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.setAttribute('aria-expanded', "false");
    setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('search-modal-open');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, this.scrollY || 0);
    }, 300);
  }
}

customElements.define('details-modal', DetailsModal);
